import { useTranslation } from "react-i18next";

import { AppLayout } from "@/components/AppLayout";
import { PermissionGate } from "@/components/PermissionGate";
import { BrandingConfigCard, NotificationTemplatesCard } from "@/modules/admin";

export default function AdminBrandingPage() {
  const { t } = useTranslation();
  return (
    <AppLayout
      title={t("admin.branding.pageTitle")}
      description={t("admin.branding.pageDescription")}
    >
      <PermissionGate
        perm="org.update"
        fallback={
          <p className="card text-sm text-nb-text-2">{t("admin.noPermission")}</p>
        }
      >
        <BrandingConfigCard />
        <NotificationTemplatesCard />
      </PermissionGate>
    </AppLayout>
  );
}
